module.exports = __webpack_public_path__ + "img/14.8c9873a9.svg";